import { render, staticRenderFns } from "./CreateANewUser.vue?vue&type=template&id=0ecae060"
import script from "./CreateANewUser.vue?vue&type=script&lang=js"
export * from "./CreateANewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports